import { useGetMyProfileQuery, useGetUserByIdQuery } from 'src/redux/api/user';

export const useMe = (skipProfile: boolean = false) => {
  const {
    data: userProfile,
    isLoading: isLoadingProfile,
    isFetching: isFetchingProfile,
    error: errorProfile,
  } = useGetMyProfileQuery(undefined, { skip: skipProfile });

  const {
    data: currentUser,
    isLoading: isLoadingUser,
    isFetching: isFetchingUser,
    error: errorUser,
  } = useGetUserByIdQuery(userProfile?.id, { skip: !userProfile?.id });

  const isLoading = isLoadingProfile || isFetchingProfile || isLoadingUser || isFetchingUser;

  return {
    currentUser,
    isLoading,
    errorUser,
    errorProfile,
  };
};
